import { isInternalUrl } from './web-post-seo';

const esc = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/** Đoạn chữ thường: URL 3 web công ty thành link, còn lại escape. */
function linkify(s: string): string {
  let html = '';
  let last = 0;
  for (const m of s.matchAll(/https?:\/\/[^\s<>"']{3,300}/g)) {
    html += esc(s.slice(last, m.index));
    const url = m[0].replace(/[.,;)]+$/, '');
    html += isInternalUrl(url) ? `<a href="${esc(url)}">${esc(url)}</a>` : esc(url);
    html += esc(m[0].slice(url.length));
    last = m.index! + m[0].length;
  }
  return html + esc(s.slice(last));
}

/**
 * Thân bài (chữ thường + "## tiêu đề phụ" + "- gạch đầu dòng" + "**đậm**" + "[chữ](link)" + "---" kẻ ngang) → HTML đơn giản, đã escape.
 * Dùng chung: máy chủ gửi web (body_html) và màn Xem trước trên ERP, nên xem trước đúng như web thật (DEC-640, DEC-720).
 * Link chỉ giữ khi trỏ về 3 web công ty; CTA và chữ ký thêm cuối bài.
 */
export function bodyToHtml(body: string, signature: string, cta = ''): string {
  const out: string[] = [];
  let list: string[] = [];
  const flush = () => {
    if (list.length) out.push(`<ul>${list.map((li) => `<li>${li}</li>`).join('')}</ul>`);
    list = [];
  };
  const bold = (s: string) => esc(s).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  const inline = (s: string) => {
    let html = '';
    let last = 0;
    for (const m of s.matchAll(/\[([^\]\n]{1,200})\]\((https?:\/\/[^\s)]{1,500})\)/g)) {
      html += bold(s.slice(last, m.index));
      html += isInternalUrl(m[2]!) ? `<a href="${esc(m[2]!)}">${esc(m[1]!)}</a>` : esc(m[1]!);
      last = m.index! + m[0].length;
    }
    return html + bold(s.slice(last));
  };
  for (const raw of body.replace(/\r/g, '').split(/\n{2,}/)) {
    for (const line of raw.split('\n')) {
      const t = line.trim();
      if (!t) continue;
      const h = /^#{1,3}\s+(.+)$/.exec(t);
      const li = /^[-•*]\s+(.+)$/.exec(t);
      if (/^(-{3,}|\*{3,}|_{3,})$/.test(t)) {
        flush();
        out.push('<hr />');
      } else if (h) {
        flush();
        out.push(`<h2>${inline(h[1]!)}</h2>`);
      } else if (li) list.push(inline(li[1]!));
      else {
        flush();
        out.push(`<p>${inline(t)}</p>`);
      }
    }
    flush();
  }
  // CTA nhiều dòng (DEC-780): giữ xuống dòng, link 3 web công ty bấm được
  if (cta.trim())
    out.push(
      `<p class="mt-cta">${cta
        .trim()
        .split(/\n+/)
        .map((l) => linkify(l.trim()))
        .filter(Boolean)
        .join('<br />')}</p>`,
    );
  out.push(`<p class="mt-signature"><em>${esc(signature)}</em></p>`);
  return out.join('\n');
}

/**
 * Link xem bài trên web thật. WordPress: `?name=<slug>` mở đúng bài dù web cài kiểu đường dẫn nào (plugin đặt post_name = slug).
 * Bài ảnh không chọn chuyên mục chỉ nằm ở trang Hình ảnh thực tế: web PCCC có đường dẫn cố định, web WordPress thì không biết → null.
 */
export function webPostLiveUrl(target: 'thepminhtien' | 'sieuthisatthep' | 'pccc', post: { kind: string; slug: string; hasCategory: boolean }): string | null {
  if (target === 'pccc') return 'https://pccc.sieuthisatthep.net/hinh-anh-thuc-te/';
  if (post.kind !== 'news' && !post.hasCategory) return null;
  const domain = target === 'thepminhtien' ? 'thepminhtien.com' : 'sieuthisatthep.net';
  return `https://${domain}/?name=${encodeURIComponent(post.slug)}`;
}
